import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ParallaxProvider } from 'react-scroll-parallax';

import theme from 'src/styles/theme';
import GlobalStyle from 'src/styles/global';
import store from 'src/redux/store';
import UpdateLanguage from 'src/plugins/language';

import App from './App';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <ParallaxProvider>
        <Router>
          <>
            <UpdateLanguage />
            <GlobalStyle />
            <App />
          </>
        </Router>
      </ParallaxProvider>
    </Provider>
  </ThemeProvider>,
  document.getElementById('app')
);
